import { notEmptyString } from "./validators";

export const mediaIdMatchPatterns = {
  vimeo: [".com/(\\d+(/\\d+)?)"],
  youtube: ["youtu.be/([^/& ]+)", "www.youtube.com/watch\\?v=([^& ]+)"],
  twitch: ["https://www.twitch.tv/videos/(\\d+)"],
  facebook: ["facebook\\.com/[a-zA-Z0-9_-]+/videos/(\\w+)"],
  soundcloud: ["soundcloud.com/([a-z0-9-]+.*?)$"],
};

export const playerPatterns = () => {
  const video = [
    {
      provider: "instagram",
      pattern: "www.instagram\\.com/tv/[a-zA-Z0-9_-]+/?utm_source=\\w+",
    },
    { provider: "youtube", pattern: "youtu.be/[a-z0-9_-]+" },
    { provider: "youtube", pattern: "www.youtube\\.com/watch\\?v=\\w+" },
    {
      provider: "youtube",
      pattern: "(www.)?youtube\\.com/user/[a-zA-Z0-9_-]+/live",
    },
    {
      provider: "facebook",
      pattern: "www.facebook\\.com/[a-zA-Z0-9_-]+/videos/\\w+",
    },
    { provider: "twitch", pattern: "www.twitch\\.tv/(videos/\\d+|\\w+)" },
    { provider: "streamable", pattern: "streamable\\.com/\\w+" },
    { provider: "vimeo", pattern: "vimeo\\.com/\\d+" },
    //{ provider: "wistia", pattern: "[a-z0-9_-]+.wistia.com/medias/\\w+" },
    { provider: "wistia", pattern: "home.wistia.com/medias/\\w+" },
    //{ provider: "wistia", pattern: "fast.wistia.net/embed/\\w+" },
    { provider: "dailymotion", pattern: "www.dailymotion.com/video/\\w+" },
    { provider: "twitch", pattern: "www.twitch.tv/videos/\\d+" },
    { provider: "vimeo", pattern: "vimeo\\.com/(event|showcase)/\\w+" },
    {
      provider: "youtube",
      pattern: "(www\\.)?youtube\\.com/playlist?list=\\w+",
    },
    {
      provider: "youtube",
      pattern: "(www\\.)?youtube\\.com/embed/live_stream\\?channel=\\w+",
    },
  ];
  const audio = [
    {
      provider: "spotify",
      pattern: "spotify:(track|album|episode|playlist|show):\\w+",
    },
    {
      provider: "spotify",
      pattern: "open.spotify.com/(track|album|episode|playlist|show)/\\w+",
    },/* 
    {
      provider: "spotify",
      pattern: "open.spotify.com/(track|album|episode|playlist)/\\w+",
    }, */
    {
      provider: "soundcloud",
      pattern: "soundcloud.com/[a-z0-9-]+.*?",
    },
  ];
  const image = [
    { provider: "instagram", pattern: "instagr\\.am/p/\\w+" },
    {
      provider: "instagram",
      pattern: "www.instagram\\.com/p/[a-zA-Z0-9_-]+/\\?utm_source=\\w+",
    },
    { provider: "sketchfab", pattern: "sketchfab\\.com/3d-models/[a-z0-9]+" },
    { provider: "adobe", pattern: "indd\\.adobe\\.com/view/\\w+" },
    {
      provider: "issuu",
      pattern: "issuu\\.com/[a-zA-Z0-9_-]+?/docs/[a-zA-Z0-9_-]+",
    },
    {
      provider: "sirv",
      pattern: "([a-z0-9_-]+\\.)?sirv\\.com/\\w+",
    },
    { provider: "sketchfab", pattern: "skfb\\.ly/\\w+" },
    { provider: "shapediver", pattern: "viewer\\.shapediver\\.com" },
    {
      provider: "cloudinary",
      pattern: "https://res.cloudinary.com/\\w+/\\w+/\\w+/[^/]+?/\\w+(\\.w+)?",
    },
  ];
  return { video, audio, image };
};

export const validPlayerUrlType = (url) => {
  const patternSets = playerPatterns();
  let valid = false;
  let type = "";
  let provider = "";
  const prefixRgx = /^\w+:/;
  if (notEmptyString(url, 5)) {
    Object.entries(patternSets).forEach((entry) => {
      const [category, patterns] = entry;
      if (patterns instanceof Array) {
        patterns.forEach((item) => {
          const prefix = prefixRgx.test(item.pattern) ? "" : "https://";
          const rgx = new RegExp("^" + prefix + item.pattern, "i");
          if (rgx.test(url)) {
            valid = true;
            type = category;
            provider = item.provider;
          }
        });
      }
    });
  }

  return { valid, type, provider };
};
